<template>
    <div class="product-add">
        <!--弹窗-->
        <!--        <el-dialog :visible.sync="selectLanguageDialogVisible" title="菜品录入使用语言" width="50%" center-->
        <!--                   :before-close="handleClose">-->
        <!--            <div class="language-container">-->
        <!--                <div class="language-button"-->
        <!--                     v-for="(item, index) in translations"-->
        <!--                     :key="index"-->
        <!--                     @click="mainLanguage = item.name"-->
        <!--                     :class="{ selected: mainLanguage === item.name }">-->
        <!--                    {{ item.text }}-->
        <!--                </div>-->
        <!--            </div>-->
        <!--            <span slot="footer" class="dialog-footer">-->
        <!--                <el-button @click="cancel">{{$t('取消')}}</el-button>-->
        <!--                <el-button type="primary" @click="confirm">{{$t('确定')}}</el-button>-->
        <!--            </span>-->
        <!--        </el-dialog>-->
        <MainLangSelDialog ref="mainLangSelDialog" @selectCallback="selectMainLanguage"></MainLangSelDialog>
        <div style="display: flex;">
            <div class="lang-dialog">
                <div class="lang-select-language">
                    <label>{{ $t('主语言选择') }}</label>
                    <el-select v-model="mainLanguage" :placeholder="$t('请选择主语言')" style="width: 60%" @change="selectMainLanguage">
                        <el-option v-for="item in translations" :key="item.text" :label="item.text" :value="item.name">
                        </el-option>
                    </el-select>
                </div>
                <div ref="langdialog">
                    <Lang :langList="langList" :activeName="activeName" @active-name-changed="updateActiveName"
                        :translateFiled="translateFiled"></Lang>
                </div>
            </div>
            <!--form表单-->
            <div class="right-contianer">
                <el-form size="small" ref="form" :model="translations[activeName].form.model" label-width="100px"
                    :loading="loading">
                    <!--基础信息-->
                    <NewBasic ref="newBasic" :activeName="activeName" @active-name-changed="updateActiveName"
                        @translateLoading="handleTranslate" @notifyLangList="handleLangList"></NewBasic>
                    <!--高级设置-->
                    <el-collapse accordion>
                        <el-collapse-item class="custom-collapse-item">
                            <template slot="title">
                                <div class="title-box">
                                    <span class="title" style="margin-left: 7px">{{ $t('高级设置') }}</span>
                                </div>
                            </template>
                            <AdSet :activeName="activeName"></AdSet>
                        </el-collapse-item>
                    </el-collapse>
                    <!--提交按钮操作-->
                    <div class="common-button-wrapper-add common-button-wrapper">
                        <el-button size="small" type="info" @click="cancelFunc">{{ $t('取消') }}</el-button>
                        <el-button size="small" type="primary" @click="onSubmit" :loading="loading"
                            style="margin-right:10px;">{{ $t('发布') }}
                        </el-button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import PorductApi from '@/api/product.js';
import NewBasic from './part/NewBasic.vue';
import AdSet from './part/Adset.vue';
import Lang from './part/Lang.vue';
import MainLangSelDialog from "../../../../components/common/mainLangSelDialog";
import { getAbsolutePosition } from '@/utils/base.js';
import bus from '@/utils/eventBus.js';

export default {
    components: {
        /*基础信息*/
        NewBasic,
        /*高级设置*/
        AdSet,
        Lang,
        MainLangSelDialog,
    },
    data() {
        return {
            activeName: "chinese",
            mainLanguage: "chinese",
            selectLanguageDialogVisible: false,
            translations: {
                chinese: {
                    text: '中文', name: 'chinese', form: {
                        model: {
                            /*菜品名称*/
                            product_name: '',
                            /*菜品分类*/
                            category_id: null,
                            ingredient: [],//菜品配料
                            product_ingredient: [],//菜品配料
                            /*菜品图片*/
                            image: [],
                            /*菜品卖点*/
                            selling_point: '',
                            /*规格类别,默认10单规格，20多规格*/
                            spec_type: 10,
                            /*库存计算方式,默认20付款减库存，10下单减库存*/
                            deduct_stock_type: 20,
                            /*检查用户等级*/
                            is_alone_grade: 0,
                            sku: [{
                                product_price: '',
                                stock_num: 9999,
                                product_weight: '',
                                cost_price: '',
                                bag_price: ""
                            }],
                            tag: [],
                            product_tag: [],
                            product_attr: [],
                            product_feed: [],
                            /* 最小购买量 */
                            min_buy: 1,
                            /* 菜品单位 */
                            product_unit: '',
                            /* 属性*/
                            /*菜品详情内容*/
                            content: '',
                            /*菜品状态*/
                            product_status: 10,
                            /*初始销量*/
                            sales_initial: 0,
                            /*菜品排序，默认100*/
                            product_sort: 100,
                            /*限购数量*/
                            limit_num: 0,
                            special_id: 0,
                            /*是否开启积分赠送,默认1为开启，0为关闭*/
                            is_points_gift: 1,
                            is_agent: 0,
                            /*是否开启单独分销,默认0为关闭，1为开启*/
                            is_ind_agent: 0,
                            /*分销佣金类型,默认10为百分比，20为固定金额*/
                            agent_money_type: 10,
                            /*一级佣金*/
                            first_money: 0,
                            /*二级佣金*/
                            second_money: 0,
                            /*三级佣金*/
                            third_money: 0,
                            /*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
                            is_enable_grade: 1,
                            /*等级金额类型,默认10为百分比，20为固定金额*/
                            alone_grade_type: 10,
                            taste: "",//口味
                            IsShowAICompletion: true,//A一键补全信息
                        }, category: [], feed: [], special: [], specData: [], sync: 1
                    }
                },
                english: {
                    text: 'English', name: 'english', form: {
                        model: {
                            /*菜品名称*/
                            product_name: '',
                            /*菜品分类*/
                            category_id: null,
                            ingredient: [],//菜品配料
                            product_ingredient: [],//菜品配料
                            /*菜品图片*/
                            image: [],
                            /*菜品卖点*/
                            selling_point: '',
                            /*规格类别,默认10单规格，20多规格*/
                            spec_type: 10,
                            /*库存计算方式,默认20付款减库存，10下单减库存*/
                            deduct_stock_type: 20,
                            /*检查用户等级*/
                            is_alone_grade: 0,
                            sku: [{
                                product_price: '',
                                stock_num: 9999,
                                product_weight: '',
                                cost_price: '',
                                bag_price: ""
                            }],
                            tag: [],
                            product_tag: [],
                            product_attr: [],
                            product_feed: [],
                            /* 最小购买量 */
                            min_buy: 1,
                            /* 菜品单位 */
                            product_unit: '',
                            /* 属性*/
                            /*菜品详情内容*/
                            content: '',
                            /*菜品状态*/
                            product_status: 10,
                            /*初始销量*/
                            sales_initial: 0,
                            /*菜品排序，默认100*/
                            product_sort: 100,
                            /*限购数量*/
                            limit_num: 0,
                            special_id: 0,
                            /*是否开启积分赠送,默认1为开启，0为关闭*/
                            is_points_gift: 1,
                            is_agent: 0,
                            /*是否开启单独分销,默认0为关闭，1为开启*/
                            is_ind_agent: 0,
                            /*分销佣金类型,默认10为百分比，20为固定金额*/
                            agent_money_type: 10,
                            /*一级佣金*/
                            first_money: 0,
                            /*二级佣金*/
                            second_money: 0,
                            /*三级佣金*/
                            third_money: 0,
                            /*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
                            is_enable_grade: 1,
                            /*等级金额类型,默认10为百分比，20为固定金额*/
                            alone_grade_type: 10,
                            taste: "",//口味
                            IsShowAICompletion: true,//A一键补全信息
                        }, category: [], feed: [], special: [], specData: [], sync: 1
                    }
                },
                italian: {
                    text: 'Italiano', name: 'italian', form: {
                        model: {
                            /*菜品名称*/
                            product_name: '',
                            /*菜品分类*/
                            category_id: null,
                            ingredient: [],//菜品配料
                            product_ingredient: [],//菜品配料
                            /*菜品图片*/
                            image: [],
                            /*菜品卖点*/
                            selling_point: '',
                            /*规格类别,默认10单规格，20多规格*/
                            spec_type: 10,
                            /*库存计算方式,默认20付款减库存，10下单减库存*/
                            deduct_stock_type: 20,
                            /*检查用户等级*/
                            is_alone_grade: 0,
                            sku: [{
                                product_price: '',
                                stock_num: 9999,
                                product_weight: '',
                                cost_price: '',
                                bag_price: ""
                            }],
                            tag: [],
                            product_tag: [],
                            product_attr: [],
                            product_feed: [],
                            /* 最小购买量 */
                            min_buy: 1,
                            /* 菜品单位 */
                            product_unit: '',
                            /* 属性*/
                            /*菜品详情内容*/
                            content: '',
                            /*菜品状态*/
                            product_status: 10,
                            /*初始销量*/
                            sales_initial: 0,
                            /*菜品排序，默认100*/
                            product_sort: 100,
                            /*限购数量*/
                            limit_num: 0,
                            special_id: 0,
                            /*是否开启积分赠送,默认1为开启，0为关闭*/
                            is_points_gift: 1,
                            is_agent: 0,
                            /*是否开启单独分销,默认0为关闭，1为开启*/
                            is_ind_agent: 0,
                            /*分销佣金类型,默认10为百分比，20为固定金额*/
                            agent_money_type: 10,
                            /*一级佣金*/
                            first_money: 0,
                            /*二级佣金*/
                            second_money: 0,
                            /*三级佣金*/
                            third_money: 0,
                            /*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
                            is_enable_grade: 1,
                            /*等级金额类型,默认10为百分比，20为固定金额*/
                            alone_grade_type: 10,
                            taste: "",//口味
                            IsShowAICompletion: true,//A一键补全信息
                        }, category: [], feed: [], special: [], specData: [], sync: 1
                    }
                },
                german: {
                    text: 'Deutsch', name: 'german', form: {
                        model: {
                            /*菜品名称*/
                            product_name: '',
                            /*菜品分类*/
                            category_id: null,
                            ingredient: [],//菜品配料
                            product_ingredient: [],//菜品配料
                            /*菜品图片*/
                            image: [],
                            /*菜品卖点*/
                            selling_point: '',
                            /*规格类别,默认10单规格，20多规格*/
                            spec_type: 10,
                            /*库存计算方式,默认20付款减库存，10下单减库存*/
                            deduct_stock_type: 20,
                            /*检查用户等级*/
                            is_alone_grade: 0,
                            sku: [{
                                product_price: '',
                                stock_num: 9999,
                                product_weight: '',
                                cost_price: '',
                                bag_price: ""
                            }],
                            tag: [],
                            product_tag: [],
                            product_attr: [],
                            product_feed: [],
                            /* 最小购买量 */
                            min_buy: 1,
                            /* 菜品单位 */
                            product_unit: '',
                            /* 属性*/
                            /*菜品详情内容*/
                            content: '',
                            /*菜品状态*/
                            product_status: 10,
                            /*初始销量*/
                            sales_initial: 0,
                            /*菜品排序，默认100*/
                            product_sort: 100,
                            /*限购数量*/
                            limit_num: 0,
                            special_id: 0,
                            /*是否开启积分赠送,默认1为开启，0为关闭*/
                            is_points_gift: 1,
                            is_agent: 0,
                            /*是否开启单独分销,默认0为关闭，1为开启*/
                            is_ind_agent: 0,
                            /*分销佣金类型,默认10为百分比，20为固定金额*/
                            agent_money_type: 10,
                            /*一级佣金*/
                            first_money: 0,
                            /*二级佣金*/
                            second_money: 0,
                            /*三级佣金*/
                            third_money: 0,
                            /*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
                            is_enable_grade: 1,
                            /*等级金额类型,默认10为百分比，20为固定金额*/
                            alone_grade_type: 10,
                            taste: "",//口味
                            IsShowAICompletion: true,//A一键补全信息
                        }, category: [], feed: [], special: [], specData: [], sync: 1
                    }
                },
                spanish: {
                    text: 'Español', name: 'spanish', form: {
                        model: {
                            /*菜品名称*/
                            product_name: '',
                            /*菜品分类*/
                            category_id: null,
                            ingredient: [],//菜品配料
                            product_ingredient: [],//菜品配料
                            /*菜品图片*/
                            image: [],
                            /*菜品卖点*/
                            selling_point: '',
                            /*规格类别,默认10单规格，20多规格*/
                            spec_type: 10,
                            /*库存计算方式,默认20付款减库存，10下单减库存*/
                            deduct_stock_type: 20,
                            /*检查用户等级*/
                            is_alone_grade: 0,
                            sku: [{
                                product_price: '',
                                stock_num: 9999,
                                product_weight: '',
                                cost_price: '',
                                bag_price: ""
                            }],
                            tag: [],
                            product_tag: [],
                            product_attr: [],
                            product_feed: [],
                            /* 最小购买量 */
                            min_buy: 1,
                            /* 菜品单位 */
                            product_unit: '',
                            /* 属性*/
                            /*菜品详情内容*/
                            content: '',
                            /*菜品状态*/
                            product_status: 10,
                            /*初始销量*/
                            sales_initial: 0,
                            /*菜品排序，默认100*/
                            product_sort: 100,
                            /*限购数量*/
                            limit_num: 0,
                            special_id: 0,
                            /*是否开启积分赠送,默认1为开启，0为关闭*/
                            is_points_gift: 1,
                            is_agent: 0,
                            /*是否开启单独分销,默认0为关闭，1为开启*/
                            is_ind_agent: 0,
                            /*分销佣金类型,默认10为百分比，20为固定金额*/
                            agent_money_type: 10,
                            /*一级佣金*/
                            first_money: 0,
                            /*二级佣金*/
                            second_money: 0,
                            /*三级佣金*/
                            third_money: 0,
                            /*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
                            is_enable_grade: 1,
                            /*等级金额类型,默认10为百分比，20为固定金额*/
                            alone_grade_type: 10,
                            taste: "",//口味
                            IsShowAICompletion: true,//A一键补全信息
                        }, category: [], feed: [], special: [], specData: [], sync: 1
                    }
                },
                french: {
                    text: 'Français', name: 'french', form: {
                        model: {
                            /*菜品名称*/
                            product_name: '',
                            /*菜品分类*/
                            category_id: null,
                            ingredient: [],//菜品配料
                            product_ingredient: [],//菜品配料
                            /*菜品图片*/
                            image: [],
                            /*菜品卖点*/
                            selling_point: '',
                            /*规格类别,默认10单规格，20多规格*/
                            spec_type: 10,
                            /*库存计算方式,默认20付款减库存，10下单减库存*/
                            deduct_stock_type: 20,
                            /*检查用户等级*/
                            is_alone_grade: 0,
                            sku: [{
                                product_price: '',
                                stock_num: 9999,
                                product_weight: '',
                                cost_price: '',
                                bag_price: ""
                            }],
                            tag: [],
                            product_tag: [],
                            product_attr: [],
                            product_feed: [],
                            /* 最小购买量 */
                            min_buy: 1,
                            /* 菜品单位 */
                            product_unit: '',
                            /* 属性*/
                            /*菜品详情内容*/
                            content: '',
                            /*菜品状态*/
                            product_status: 10,
                            /*初始销量*/
                            sales_initial: 0,
                            /*菜品排序，默认100*/
                            product_sort: 100,
                            /*限购数量*/
                            limit_num: 0,
                            special_id: 0,
                            /*是否开启积分赠送,默认1为开启，0为关闭*/
                            is_points_gift: 1,
                            is_agent: 0,
                            /*是否开启单独分销,默认0为关闭，1为开启*/
                            is_ind_agent: 0,
                            /*分销佣金类型,默认10为百分比，20为固定金额*/
                            agent_money_type: 10,
                            /*一级佣金*/
                            first_money: 0,
                            /*二级佣金*/
                            second_money: 0,
                            /*三级佣金*/
                            third_money: 0,
                            /*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
                            is_enable_grade: 1,
                            /*等级金额类型,默认10为百分比，20为固定金额*/
                            alone_grade_type: 10,
                            taste: "",//口味
                            IsShowAICompletion: true,//A一键补全信息
                        }, category: [], feed: [], special: [], specData: [], sync: 1
                    }
                },
                croatia: {
                    text: 'Hrvatska', name: 'croatia', form: {
                        model: {
                            /*菜品名称*/
                            product_name: '',
                            /*菜品分类*/
                            category_id: null,
                            ingredient: [],//菜品配料
                            product_ingredient: [],//菜品配料
                            /*菜品图片*/
                            image: [],
                            /*菜品卖点*/
                            selling_point: '',
                            /*规格类别,默认10单规格，20多规格*/
                            spec_type: 10,
                            /*库存计算方式,默认20付款减库存，10下单减库存*/
                            deduct_stock_type: 20,
                            /*检查用户等级*/
                            is_alone_grade: 0,
                            sku: [{
                                product_price: '',
                                stock_num: 9999,
                                product_weight: '',
                                cost_price: '',
                                bag_price: ""
                            }],
                            tag: [],
                            product_tag: [],
                            product_attr: [],
                            product_feed: [],
                            /* 最小购买量 */
                            min_buy: 1,
                            /* 菜品单位 */
                            product_unit: '',
                            /* 属性*/
                            /*菜品详情内容*/
                            content: '',
                            /*菜品状态*/
                            product_status: 10,
                            /*初始销量*/
                            sales_initial: 0,
                            /*菜品排序，默认100*/
                            product_sort: 100,
                            /*限购数量*/
                            limit_num: 0,
                            special_id: 0,
                            /*是否开启积分赠送,默认1为开启，0为关闭*/
                            is_points_gift: 1,
                            is_agent: 0,
                            /*是否开启单独分销,默认0为关闭，1为开启*/
                            is_ind_agent: 0,
                            /*分销佣金类型,默认10为百分比，20为固定金额*/
                            agent_money_type: 10,
                            /*一级佣金*/
                            first_money: 0,
                            /*二级佣金*/
                            second_money: 0,
                            /*三级佣金*/
                            third_money: 0,
                            /*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
                            is_enable_grade: 1,
                            /*等级金额类型,默认10为百分比，20为固定金额*/
                            alone_grade_type: 10,
                            taste: "",//口味
                            IsShowAICompletion: true,//A一键补全信息
                        }, category: [], feed: [], special: [], specData: [], sync: 1
                    }
                },
                slovenia: {
                    text: 'Slovenščina', name: 'slovenia', form: {
                        model: {
                            /*菜品名称*/
                            product_name: '',
                            /*菜品分类*/
                            category_id: null,
                            ingredient: [],//菜品配料
                            product_ingredient: [],//菜品配料
                            /*菜品图片*/
                            image: [],
                            /*菜品卖点*/
                            selling_point: '',
                            /*规格类别,默认10单规格，20多规格*/
                            spec_type: 10,
                            /*库存计算方式,默认20付款减库存，10下单减库存*/
                            deduct_stock_type: 20,
                            /*检查用户等级*/
                            is_alone_grade: 0,
                            sku: [{
                                product_price: '',
                                stock_num: 9999,
                                product_weight: '',
                                cost_price: '',
                                bag_price: ""
                            }],
                            tag: [],
                            product_tag: [],
                            product_attr: [],
                            product_feed: [],
                            /* 最小购买量 */
                            min_buy: 1,
                            /* 菜品单位 */
                            product_unit: '',
                            /* 属性*/
                            /*菜品详情内容*/
                            content: '',
                            /*菜品状态*/
                            product_status: 10,
                            /*初始销量*/
                            sales_initial: 0,
                            /*菜品排序，默认100*/
                            product_sort: 100,
                            /*限购数量*/
                            limit_num: 0,
                            special_id: 0,
                            /*是否开启积分赠送,默认1为开启，0为关闭*/
                            is_points_gift: 1,
                            is_agent: 0,
                            /*是否开启单独分销,默认0为关闭，1为开启*/
                            is_ind_agent: 0,
                            /*分销佣金类型,默认10为百分比，20为固定金额*/
                            agent_money_type: 10,
                            /*一级佣金*/
                            first_money: 0,
                            /*二级佣金*/
                            second_money: 0,
                            /*三级佣金*/
                            third_money: 0,
                            /*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
                            is_enable_grade: 1,
                            /*等级金额类型,默认10为百分比，20为固定金额*/
                            alone_grade_type: 10,
                            taste: "",//口味
                            IsShowAICompletion: true,//A一键补全信息
                        }, category: [], feed: [], special: [], specData: [], sync: 1
                    }
                },
                hungarian: {
                    text: 'Magyar', name: 'hungarian', form: {
                        model: {
                            /*菜品名称*/
                            product_name: '',
                            /*菜品分类*/
                            category_id: null,
                            ingredient: [],//菜品配料
                            product_ingredient: [],//菜品配料
                            /*菜品图片*/
                            image: [],
                            /*菜品卖点*/
                            selling_point: '',
                            /*规格类别,默认10单规格，20多规格*/
                            spec_type: 10,
                            /*库存计算方式,默认20付款减库存，10下单减库存*/
                            deduct_stock_type: 20,
                            /*检查用户等级*/
                            is_alone_grade: 0,
                            sku: [{
                                product_price: '',
                                stock_num: 9999,
                                product_weight: '',
                                cost_price: '',
                                bag_price: ""
                            }],
                            tag: [],
                            product_tag: [],
                            product_attr: [],
                            product_feed: [],
                            /* 最小购买量 */
                            min_buy: 1,
                            /* 菜品单位 */
                            product_unit: '',
                            /* 属性*/
                            /*菜品详情内容*/
                            content: '',
                            /*菜品状态*/
                            product_status: 10,
                            /*初始销量*/
                            sales_initial: 0,
                            /*菜品排序，默认100*/
                            product_sort: 100,
                            /*限购数量*/
                            limit_num: 0,
                            special_id: 0,
                            /*是否开启积分赠送,默认1为开启，0为关闭*/
                            is_points_gift: 1,
                            is_agent: 0,
                            /*是否开启单独分销,默认0为关闭，1为开启*/
                            is_ind_agent: 0,
                            /*分销佣金类型,默认10为百分比，20为固定金额*/
                            agent_money_type: 10,
                            /*一级佣金*/
                            first_money: 0,
                            /*二级佣金*/
                            second_money: 0,
                            /*三级佣金*/
                            third_money: 0,
                            /*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
                            is_enable_grade: 1,
                            /*等级金额类型,默认10为百分比，20为固定金额*/
                            alone_grade_type: 10,
                            taste: "",//口味
                            IsShowAICompletion: true,//A一键补全信息
                        }, category: [], feed: [], special: [], specData: [], sync: 1
                    }
                },
            },
            part: "takeaway",
            placeholder: null,
            /*是否正在加载*/
            loading: false,
            translateLoading: false,
            langList: [],
            translateFiled: '',
            form: {
                model: {
                    /*菜品名称*/
                    product_name: '',
                    /*菜品分类*/
                    category_id: null,
                    ingredient: [],//菜品配料
                    product_ingredient: [],//菜品配料
                    /*菜品图片*/
                    image: [],
                    /*菜品卖点*/
                    selling_point: '',
                    /*规格类别,默认10单规格，20多规格*/
                    spec_type: 10,
                    /*库存计算方式,默认20付款减库存，10下单减库存*/
                    deduct_stock_type: 20,
                    /*检查用户等级*/
                    is_alone_grade: 0,
                    sku: [{
                        product_price: '',
                        stock_num: 9999,
                        product_weight: '',
                        cost_price: '',
                        bag_price: ""
                    }],
                    tag: [],
                    product_tag: [],
                    product_attr: [],
                    product_feed: [],
                    /* 最小购买量 */
                    min_buy: 1,
                    /* 菜品单位 */
                    product_unit: '',
                    /* 属性*/
                    /*菜品详情内容*/
                    content: '',
                    /*菜品状态*/
                    product_status: 10,
                    /*初始销量*/
                    sales_initial: 0,
                    /*菜品排序，默认100*/
                    product_sort: 100,
                    /*限购数量*/
                    limit_num: 0,
                    special_id: 0,
                    /*是否开启积分赠送,默认1为开启，0为关闭*/
                    is_points_gift: 1,
                    is_agent: 0,
                    /*是否开启单独分销,默认0为关闭，1为开启*/
                    is_ind_agent: 0,
                    /*分销佣金类型,默认10为百分比，20为固定金额*/
                    agent_money_type: 10,
                    /*一级佣金*/
                    first_money: 0,
                    /*二级佣金*/
                    second_money: 0,
                    /*三级佣金*/
                    third_money: 0,
                    /*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
                    is_enable_grade: 1,
                    /*等级金额类型,默认10为百分比，20为固定金额*/
                    alone_grade_type: 10,
                    taste: "",//口味
                    IsShowAICompletion: true,//A一键补全信息
                },
                /*菜品分类*/
                category: [],
                feed: [],
                special: [],
                /*规格数据*/
                specData: [],
                sync: 1,
                /*会员等级*/
                gradeList: [],
                /*分销基础设置*/
                basicSetting: {},
                /*分销佣金设置*/
                agentSetting: {},
                /*运费模板*/
                delivery: [],
            },

        };
    },
    provide: function () {
        return {
            translations: this.translations,
            activeName: this.activeName
        }
    },
    mounted() {
        let lang = localStorage.getItem("mainLanguage")
        if (!lang) {
            this.$refs.mainLangSelDialog.selectLanguageDialogVisible = true;
        } else {
            this.mainLanguage = lang
            // this.selectMainLanguage(this.mainLanguage);
            // this.activeName = this.mainLanguage
            this.$refs.mainLangSelDialog.selectLanguageDialogVisible = false;
        }

        // if (localStorage.getItem("mainLanguage") == undefined || localStorage.getItem("mainLanguage") == null) {
        //
        // } else {
        //
        // }
        bus.$on('changeLangPosition', this.changeLangPosition)
    },
    async created() {
        /*获取基础数据*/
        await this.getBaseData();
    },
    methods: {
        /*获取基础数据*/
        getBaseData: function () {
            let self = this;
            PorductApi.takeGetBaseData({}, true)
                .then(res => {
                    self.loading = false;
                    Object.assign(self.form, res.data);
                    this.setFormValues(self.form)
                })
                .catch(error => {
                    self.loading = false;
                });
        },
        //改变多语言框的位置
        changeLangPosition(scrollTop) {
            let el = this.$refs.langdialog
            let coordinate = getAbsolutePosition(el)
            var dialog = this.$el.querySelector('.lang-dialog');
            if (coordinate.top <= 106) {
                if (!this.placeholder) {
                    this.placeholder = document.createElement('div');
                    this.placeholder.style.width = dialog.offsetWidth + 'px';
                    this.placeholder.style.height = dialog.offsetHeight + 'px';
                    this.placeholder.style.flexShrink = 0;
                    dialog.parentNode.insertBefore(this.placeholder, dialog);
                }
                if (dialog) {
                    dialog.classList.add('lang-dialog-flex');
                }
            } else {
                if (dialog) {
                    dialog.classList.remove('lang-dialog-flex');
                }
                if (this.placeholder) {
                    this.placeholder.parentNode.removeChild(this.placeholder);
                    this.placeholder = null;
                }
            }
        },
        //首次必须选择主语言的弹窗确认取消以及关闭操作
        confirm() {
            if (this.mainLanguage) {
                localStorage.setItem("mainLanguage", this.mainLanguage)
                this.langList = this.$refs.newBasic.composeLangStatus(0);
                this.selectLanguageDialogVisible = false;
            } else {
                this.$message({
                    type: 'warning',
                    message: this.$t('请先选择一个选项')
                });
            }
        },
        cancel() {
            if (this.mainLanguage) {
                this.selectLanguageDialogVisible = false;
            } else {
                this.$message({
                    type: 'warning',
                    message: this.$t('请先选择一个选项')
                });
            }
        },
        handleClose(done) {
            if (this.mainLanguage) {
                done();
            } else {
                this.$message({
                    type: 'warning',
                    message: this.$t('请先选择一个选项')
                });
            }
        },
        //选择主语言下拉菜单的操作
        selectMainLanguage(value) {
            localStorage.setItem("mainLanguage", value)
            this.activeName = value
            console.log(this.$refs.newBasic)
            this.langList = this.$refs.newBasic.composeLangStatus(0);
        },
        //子组件更改当前选中的语言表单
        updateActiveName(newName) {
            this.activeName = newName;
        },
        //子组件中翻译的状态信息
        handleTranslate(status) {
            this.translateLoading = status;
        },
        //多语言组件的列表信息
        handleLangList(langList, translateFiled) {
            this.langList = langList;
            this.translateFiled = translateFiled
        },
        setFormValues(data) {
            let categoryID = parseInt(localStorage.getItem("addProductCategoryid"), 10)
            for (let key in this.translations) {
                // 使用深拷贝来创建独立的数据对象
                let dataCopy = JSON.parse(JSON.stringify(data));
                this.$set(this.translations[key], 'form', dataCopy);
                if (categoryID != 0) {
                    this.$set(this.translations[key].form.model, 'category_id', categoryID);
                }
            }
            this.categoryLabel()
            console.log('translations', this.translations)
        },

        categoryLabel() {
            let mainLanguage = localStorage.getItem("mainLanguage")
            if (this.translations && this.translations[mainLanguage]) {
                this.translations[mainLanguage].form.category = this.translations[mainLanguage].form.category.map(item => {
                    let category, name;
                    if (item.lang && item.lang.category) {
                        category = JSON.parse(item.lang.category)
                        if (category) {
                            const key = mainLanguage
                            if (category[key] != undefined) {
                                name = category[key]
                            } else {
                                name = item.name
                            }
                        } else {
                            name = item.name
                        }
                        return {
                            category_id: item.category_id,
                            name: name
                        }
                    } else {
                        return {
                            category_id: item.category_id,
                            name: item.name
                        }
                    }
                })
            }
        },
        /*转JSON字符串*/
        convertJson(list) {
            let obj = {};
            list.forEach(item => {
                obj[item.grade_id] = item.product_equity;
            });
            return JSON.stringify(obj);
        },

        resetSubmitFormData(originalData) {
            let newFormModel = {
                product_name: originalData.product_name,
                ingredient: originalData.ingredient,
                selling_point: originalData.selling_point,
                product_tag: originalData.product_tag,
                content: originalData.content,
                taste: originalData.taste,
            }
            return newFormModel
        },

        /*提交*/
        onSubmit: function () {
            if (this.translateLoading) {
                this.$message({
                    message: this.$t('正在完成翻译，请稍后操作'),
                    type: 'warning'
                });
                return
            }
            let mainLanguage = localStorage.getItem('mainLanguage')
            let self = this;
            let params = self.translations[mainLanguage].form.model;
            self.$refs.form.validate((valid, errors) => {
                if (valid) {
                    self.loading = true;
                    params.alone_grade_equity = self.convertJson(self.form.gradeList);
                    let ingredient = params.ingredient
                    params.product_ingredient = ingredient;
                    console.log('params.ingredient', ingredient)
                    params.product_lang = JSON.stringify({
                        english: this.resetSubmitFormData(this.translations.english.form.model),
                        italian: this.resetSubmitFormData(this.translations.italian.form.model),
                        german: this.resetSubmitFormData(this.translations.german.form.model),
                        spanish: this.resetSubmitFormData(this.translations.spanish.form.model),
                        french: this.resetSubmitFormData(this.translations.french.form.model),
                        chinese: this.resetSubmitFormData(this.translations.chinese.form.model),
                        croatia: this.resetSubmitFormData(this.translations.croatia.form.model),
                        slovenia: this.resetSubmitFormData(this.translations.slovenia.form.model),
                        hungarian: this.resetSubmitFormData(this.translations.hungarian.form.model),
                    })
                    if (self.translations[mainLanguage].form.sync == 1) {
                        // 将两个请求包装在Promise.all()中
                        Promise.all([
                            PorductApi.storeAddProduct({ params: JSON.stringify(params) }, true),
                            PorductApi.takeAddProduct({ params: JSON.stringify(params) }, true)
                        ])
                            .then(([storeAddProductData, takeAddProductData]) => {
                                // 处理两个请求的结果
                                self.loading = false;
                                self.$message({
                                    message: self.$t('添加成功'),
                                    type: 'success'
                                });
                                self.$router.push('/product/takeaway/product/index');
                            })
                            .catch(error => {
                                self.loading = false;
                            });
                    } else {
                        PorductApi.takeAddProduct({
                            params: JSON.stringify(params)
                        }, true)
                            .then(data => {
                                self.loading = false;
                                self.$message({
                                    message: self.$t('添加成功'),
                                    type: 'success'
                                });
                                self.$router.push('/product/takeaway/product/index');
                            })
                            .catch(error => {
                                self.loading = false;
                            });
                    }
                } else {
                    console.log('验证失败的字段:', errors);
                    alert(this.$t("请检查表单的必填项是否全部填写"))
                }
            });
        },
        /*保存为草稿*/
        Draft() {
            let self = this;
            self.form.model.product_status = 30;
            self.onSubmit();
        },
        /*取消*/
        cancelFunc() {
            this.$router.back(-1);
        }
    },
    beforeDestroy() {
        bus.$off('changeLangPosition');
    },

};
</script>

<style lang="scss" scoped>
.basic-setting-content {}

.title-box {
    position: relative;
    height: 30px;
    padding-left: 20px;
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 12px;
}

.title:before {
    position: absolute;
    content: "";
    width: 4px;
    height: 14px;
    left: 5px;
    top: 25px;
    transform: translateY(-50%);
}

.title:before {
    background: #3a8ee6;
}

.product-add {
    padding-bottom: 50px;
}

.big-text {
    font-size: 20px;
}

.lang-dialog {
    width: 180px;
}

.right-contianer {
    flex: 5;
}

.lang-select-language {
    margin-bottom: 20px;
}

.lang-dialog-flex {
    position: fixed;
    top: 80px;
    left: 232px;
    z-index: 5;
}

.language-container {
    display: flex;
    flex-wrap: wrap;
}

.language-button {
    width: 18%;
    box-sizing: border-box;
    padding: 10px;
    text-align: center;
    border: 1px solid #DCDFE6;
    margin: 5px;
}

.language-button:hover {
    cursor: pointer;
    background-color: #409EFF;
    border-color: #409EFF;
    color: #FFF;
}

.language-container .selected {
    background-color: #409EFF;
    border-color: #409EFF;
    color: #FFF;
}

.custom-collapse-item .el-collapse-item__header {
    justify-content: flex-start;
}

.custom-collapse-item .el-collapse-item__header .el-collapse-item__arrow {
    position: relative;
    left: 10px;
    /* 你可以根据需要调整这个值 */
}
</style>



// WEBPACK FOOTER //
// src/views/product/takeaway/product/add.vue